import React from "react";
import { AnnouncedProps } from "./Announced.types";
import { useAnnouncementsStateContext } from "./AnnouncementsProvider";

export interface AppAnnouncerProps {
    /**
     * Announcer component to be rendered
     */
    readonly announcedComponent: React.FC<AnnouncedProps>;
}

export const AppAnnouncer: React.FC<AppAnnouncerProps> = ({
    announcedComponent: AnnouncedComponent
}) => {

    const allAnnouncements = useAnnouncementsStateContext();

    return (
        <>
            {
                allAnnouncements.announcements.map((announcement, index) => {
                    return <AnnouncedComponent key={index} {...announcement} />;
                })
            }
        </>
    );
};
